import React from "react";
import styles from "./shipments-zero-state.module.css";
import { IconBoxemBox } from "../icons/IconBoxemBox";
import { IconBoxemBoxSearch } from "../icons/IconBoxemBoxSearch";
import Button from "../forms/Button/Button";
import IconPlus from "../icons/IconPlus";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type ShipmentsZeroStateProps = {
  type: "default" | "shipped" | "closed" | "search" | "loading" | "fbm";
  onCreateShipment?: () => void;
  onClearSearch?: () => void;
};

const ShipmentsZeroState = ({
  type,
  onCreateShipment,
  onClearSearch,
}: ShipmentsZeroStateProps) => {
  return (
    <div className={styles.zeroStateContainer}>
      {type === "loading" ? (
        <div className={styles.loaderContainer}>
          <LoadingSpinner size="3rem" />
        </div>
      ) : (
        <div className={styles.zeroStateContentContainer}>
          {type === "search" ? (<IconBoxemBoxSearch size={160} />) : (<IconBoxemBox size={160} />)}
          <div className={styles.zeroStateHeaderText}>
            {type === "default" && "No shipments yet"}
            {type === "shipped" && "No shipped shipments yet"}
            {type === "closed" && "No closed shipments yet"}
            {type === "search" && "No shipment found matching your criteria"}
            {type === "fbm" && "No FBM Listings yet"}
          </div>
          <div className={styles.zeroStateSubText}>
            {type === "default" && "You haven't created a shipment yet. Start by creating your first one."}
            {type === "shipped" && "None of your shipments have been shipped yet."}
            {type === "closed" && "None of your shipments have been closed yet."}
            {type === "search" && "Try adjusting your filters to find the shipment you're looking for."}
            {type === "fbm" && "You haven't create an FBM Listing yet. Start by creating your first one."}
          </div>
          <div className={styles.zeroStateButtonContainer}>
            {type === "default" && (
              <Button
                type="primary"
                onClick={onCreateShipment}
                className={styles.zeroStateButton}
              >
                <IconPlus />
                Create shipment
              </Button>
            )}
            {type === "search" && (
              <Button
                type="secondary"
                onClick={onClearSearch}
                className={styles.zeroStateButton}
              >
                Clear search
              </Button>
            )}
            {type === "fbm" && (
              <Button
                type="secondary"
                onClick={onCreateShipment}
                className={styles.zeroStateButton}
              >
                Create FBM Listing
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipmentsZeroState;